// plop_marker:layouts_import
import SalesPhoneEnterprise from "./sales-phone-enterprise";
import AsymmetricEnterprise from "./asymmetric-enterprise";

export default {
  // plop_marker:layouts_add_layout
  SalesPhoneEnterprise,
  AsymmetricEnterprise,
};
